import React from 'react';
import { SoloLegalLayout } from '../components/SoloLegalLayout';

const ContactPage = () => (
  <SoloLegalLayout title="Contact">
    <p className="text-gray-700 dark:text-gray-300">
      <strong>Email:</strong>{' '}
      <a href="mailto:contact@sen-ed.co.uk" className="text-purple-600 hover:text-purple-700 dark:text-purple-400 dark:hover:text-purple-300 underline">contact@sen-ed.co.uk</a>.{' '}
      <strong>Support:</strong>{' '}
      <a href="mailto:support@sen-ed.co.uk" className="text-purple-600 hover:text-purple-700 dark:text-purple-400 dark:hover:text-purple-300 underline">support@sen-ed.co.uk</a>.
    </p>
    <p className="text-gray-700 dark:text-gray-300">
      <strong>We never ask for your password by email or by phone.</strong> Log in only via the link above (<strong>app.sen-education.co.uk</strong>) or your bookmarked address. We do not send login links by email.
    </p>
    <p className="text-gray-700 dark:text-gray-300">
      <strong>If you see SEN-Education or our branding used in a way that concerns you</strong> (e.g. unexpected emails or links), contact{' '}
      <a href="mailto:contact@sen-ed.co.uk" className="text-purple-600 hover:text-purple-700 dark:text-purple-400 dark:hover:text-purple-300 underline">contact@sen-ed.co.uk</a>.
    </p>
    <p className="text-gray-700 dark:text-gray-300">
      <strong>If your network blocks this site:</strong> Ask your IT team or provider to whitelist <strong>sen-education.co.uk</strong> (this page) and <strong>app.sen-education.co.uk</strong> (the app, for login) under <strong>Education</strong> or <strong>Professional</strong>. Both use standard HTTPS only.
    </p>
  </SoloLegalLayout>
);

export default ContactPage;
